// Import the functions you need from the SDKs you need
import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const environment = import.meta.env.VITE_ENVIRONMENT || "development";

let firebaseConfig;
if (environment === "development") {
  firebaseConfig = {
    apiKey: "AIzaSyBLMWIllGgK7uN5anxzYNNz3j2LSQ2-UnU",
    authDomain: "dashpet-dev.firebaseapp.com", // literal-ok: public dev Firebase web config
    databaseURL:
      "https://dashpet-dev-default-rtdb.europe-west1.firebasedatabase.app", // literal-ok: public dev Firebase web config
    projectId: "dashpet-dev", // literal-ok: public dev Firebase web config
    storageBucket: "dashpet-dev.firebasestorage.app", // literal-ok: public dev Firebase web config
    messagingSenderId: "905499851568",
    appId: "1:905499851568:web:b95e33c5c764faf5eae6f5",
  };
} else if (environment === "production") {
  firebaseConfig = {
    apiKey: "AIzaSyBvaASHtXo6P-nB2SPMPC0SRWdMi7E8_2E",
    authDomain: "dashpet-prod.firebaseapp.com", // literal-ok: public prod Firebase web config
    projectId: "dashpet-prod", // literal-ok: public prod Firebase web config
    databaseURL:
      "https://dashpet-prod-default-rtdb.europe-west1.firebasedatabase.app/", // literal-ok: public prod Firebase web config
    storageBucket: "dashpet-prod.firebasestorage.app", // literal-ok: public prod Firebase web config
    messagingSenderId: "945343676278",
    appId: "1:945343676278:web:6449005437c4a5840a8457",
  };
} else if (environment === "staging") {
  firebaseConfig = {
    apiKey: "AIzaSyAFNWNJYHh7T_xwbFutSU3f3RgbiaJU_eg",
    authDomain: "dashpet-stg.firebaseapp.com", // literal-ok: public staging Firebase web config
    projectId: "dashpet-stg", // literal-ok: public staging Firebase web config
    databaseURL:
      "https://dashpet-stg-default-rtdb.europe-west1.firebasedatabase.app", // literal-ok: public staging Firebase web config
    storageBucket: "dashpet-stg.firebasestorage.app", // literal-ok: public staging Firebase web config
    messagingSenderId: "339421597844",
    appId: "1:339421597844:web:97a9d458964d1e84f12481",
  };
}

// Initialize Firebase
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Firebase project id for the active environment — used to derive the
// Cloud Functions base URL for admin API calls.
export const projectId = firebaseConfig.projectId;

// Cloud Storage bucket for the active environment — used by the relocated
// DashAI admin panel to build public storage URLs (export-style thumbnails).
export const STORAGE_BUCKET = firebaseConfig.storageBucket;
